export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_FAVOURITE = "SET_FAVOURITE";
export const SET_ENROLLED_COURSES = "SET_ENROLLED_COURSES";
export const SET_PENDING_COURSES = "SET_PENDING_COURSES";